import { Box } from '@mui/material'
import { type SelectOption, SelectWithLabel } from 'Components/SelectWithLabel'
import { TextFieldWithLabel } from 'Components/TextField'
import { useState, useEffect } from 'react'
import { sendGet } from 'hooks/use-fetch'

export interface DuplicateListSearchCriteria {
  childName: string
  caregiverName: string
  source: 'All' | 'CP' | 'CC' | 'SC'
  isResolved: 'All' | 'Y' | 'N'
  isdID: number | null
}

interface Props {
  showISD: boolean
  current: DuplicateListSearchCriteria
  onChange: (newSearch: DuplicateListSearchCriteria) => void
}

export function DuplicateListSearchOptions (props: Props): JSX.Element {
  const [isds, setISDs] = useState<Array<SelectOption<number>>>([])
  const sourceOptions: Array<{ id: string, name: string }> = [
    { id: 'All', name: 'Show All' },
    { id: 'CaregiverPortal', name: 'Caregiver Portal' },
    { id: 'Child', name: 'Child Creation' },
    { id: 'Sibling', name: 'Sibling Creation' }
  ]

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet('/Reporting/AllISDs', {})
      setISDs(response)
    }
    void fetchData()
  }, [])

  const handleChange = (e: any): void => {
    props.onChange({ ...props.current, [e.target.name]: e.target.value })
  }

  return (<Box sx={{ boxSizing: 'border-box', alignItems: 'center', p: '4px 0px', gap: '10px', display: 'flex', flexDirection: 'row' }}>
    <TextFieldWithLabel
      label='Child Name'
      placeHolder='Last or first name'
      onChange={handleChange}
      name='childName'
      maxWidth='205px'
      value={props.current.childName}
      data-testid="child-name-search"
    />
    <TextFieldWithLabel
      label='Caregiver Name'
      placeHolder='Last or first name'
      onChange={handleChange}
      name='caregiverName'
      maxWidth='205px'
      value={props.current.caregiverName}
      data-testid="caregiver-name-search"
    />
    <SelectWithLabel
      name='source'
      label='Source'
      width='180px'
      value={props.current.source}
      options={sourceOptions}
      onChange={handleChange}
    />
    <SelectWithLabel
      name='isResolved'
      label='Resolved?'
      width='125px'
      value={props.current.isResolved}
      options={[
        { id: 'All', name: 'Both' },
        { id: 'Y', name: 'Yes' },
        { id: 'N', name: 'No' }
      ]}
      onChange={handleChange}
    />
    {props.showISD && <SelectWithLabel
      name="isdID"
      label="ISD"
      value={props.current.isdID ?? undefined}
      includeNoneOption={true}
      noneOptionText='(all)'
      width="200px"
      options={isds}
      onChange={handleChange}
    />
    }
  </Box>
  )
}
